module.exports = __webpack_public_path__ + "img/sect4-11.84ff79fa.png";